export default __webpack_public_path__ + "static/ApercuMonoProBold-801f978c3d25d31d5e50cad9391fc55b.woff";